import { useState, useEffect, useCallback } from "react";
import type { Hotel } from "@/types";
import { hotelApi } from "@/api/hotels/hotel.api";
import { success } from "@/utils/common";

export function useHotel() {
    const [hotels, setHotels] = useState<Hotel[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);

    const fetchHotels = useCallback(async () => {
        setIsLoading(true);
        setError(null);
        try {
            const response = await hotelApi.getAllPublic();
            setHotels(response.data ?? []);
        } catch (err) {
            setError(err as Error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    const handleDelete = async (id: number) => {
        if (!window.confirm('Bạn có chắc chắn muốn xóa không?')) return;
        try {
            await hotelApi.delete(id);
            setHotels((prev) => prev.filter((hotel) => hotel.id !== id));
            success('Xóa phòng thành công!');
        } catch (_) {
            alert('Xóa phòng thất bại, thử lại sau!');
        }
    };


    useEffect(() => {
        fetchHotels();
    }, [fetchHotels]);

    return {
        isLoading,
        hotels,
        error,
        actions: {
            setHotels,
            handleDelete
        }
    };
}



